var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"background-3",rawName:"v-background-3"}],staticClass:"w-100 p-3 rounded mb-3"},[_c('h5',[_vm._v("Déclarations")]),_c('div',[_vm._v(" Module en cours de fabrication... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }